import { RouteConfig } from 'react-router-config';
import { isInternal, isWOA } from '@/infrastructure/auth';
import { InternalPermission } from '@/presentation/pages/product/internal-permission';
import { Permission } from '@/presentation/pages/product/permission';
import { stores } from '@/presentation/store';

export const flatten = (routes: RouteConfig[]) => {
  const { permission, hasProduct, isSuperUser } = stores.ProductStore;
  const permissionComponent = !isWOA() ? InternalPermission : Permission;

  let flattenRoutes: RouteConfig[] = [];
  routes?.forEach((route) => {
    if (route.routes) {
      const subRoutes = flatten(route.routes);
      flattenRoutes = flattenRoutes.concat(subRoutes);
      return;
    }

    // 路由禁止
    if (route.disabled) {
      return;
    }

    // 需要超管权限但用户不是超管
    if (route.requireSuperAdmin && !isSuperUser) {
      flattenRoutes.push({
        ...route,
        component: permissionComponent,
      });
      return;
    }

    // 无产品，且非白名单路由
    if (isInternal() && !hasProduct && !route.pmWhitelisted) {
      flattenRoutes.push({
        ...route,
        component: permissionComponent,
      });
      return;
    }

    // 白名单
    if (route.whitelisted) {
      flattenRoutes.push(route);
      return;
    }

    // 无权限
    if (!permission) {
      flattenRoutes.push({
        ...route,
        component: permissionComponent,
      });
      return;
    }

    flattenRoutes.push(route);
  });
  return flattenRoutes;
};
